import React from 'react';
import { Heading, Section, Tile } from '@carbon/react';
import { Analytics as AnalyticsIcon } from '@carbon/icons-react';
import PageContainer from '../components/PageContainer';

const Analytics = () => {
  return (
    <PageContainer>
      <Section>
        <Heading style={{ marginBottom: '2rem' }}>
          <AnalyticsIcon size={32} style={{ marginRight: '1rem', verticalAlign: 'middle' }} />
          Analytics
        </Heading>
        <div className="grid-container">
          <Tile>
            <h4>Total Users</h4>
            <p style={{ fontSize: '2rem', fontWeight: '500' }}>12,543</p>
          </Tile>
          <Tile>
            <h4>Active Sessions</h4>
            <p style={{ fontSize: '2rem', fontWeight: 500 }}>3,421</p>
          </Tile>
          <Tile>
            <h4>Page Views</h4>
            <p style={{ fontSize: '2rem', fontWeight: 500 }}>45,892</p>
          </Tile>
        </div>
      </Section>
    </PageContainer>
  );
};

export default Analytics;
